import {
    Datagrid,
    DateField,
    List,
    NumberField,
    TextField,
    useListContext
} from 'react-admin';
import ClickableImageField from '../fields/ClickableImageField';
import { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Stack, TextField as MuiTextField, MenuItem } from '@mui/material';

const TravelFilterPanel = () => {
    const { filterValues, setFilters } = useListContext();

    const [title, setTitle] = useState(filterValues.title || '');
    const [statuses, setStatuses] = useState(filterValues.statuses || '');

    useEffect(() => {
        const delay = setTimeout(() => {
            const newFilters = { title, statuses };

            const filtersChanged =
                filterValues.title !== title ||
                filterValues.statuses !== statuses;

            if (filtersChanged) {
                setFilters(newFilters, true);
            }
        }, 400);

        return () => clearTimeout(delay);
    }, [title, statuses]);

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Фильтры
                </Typography>
                <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                    <MuiTextField
                        label="Поиск по названию"
                        variant="outlined"
                        size="small"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="например, Алтай"
                        fullWidth
                    />
                    <MuiTextField
                        label="Статус"
                        variant="outlined"
                        size="small"
                        select
                        value={statuses}
                        onChange={(e) => setStatuses(e.target.value)}
                        fullWidth
                    >
                        <MenuItem value="">Все</MenuItem>
                        <MenuItem value="planning">Планируется</MenuItem>
                        <MenuItem value="processing">В процессе</MenuItem>
                        <MenuItem value="finished">Завершено</MenuItem>
                    </MuiTextField>
                </Stack>
            </CardContent>
        </Card>
    );
};

export const TravelList = (props) => (
    <List
        {...props}
        filters={false}
        sort={{ field: 'created_at', order: 'DESC' }} // фикс сортировка
    >
        <TravelFilterPanel />

        <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="title" />
            <TextField source="status" />
            <ClickableImageField source="cover_image" />
            <DateField source="start_at" />
            <DateField source="end_at" />
            <NumberField source="cost" />
            <TextField source="currency.name" />
            <NumberField source="cost_user_currency" />
            <TextField source="user_currency.name" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </Datagrid>
    </List>
);
